import axios from 'axios';

// Remove trailing slash if present
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1').replace(/\/$/, '');

const getAuthHeaders = () => {
  // For user portal endpoints, use user portal token
  // For trainer/admin endpoints, use access token
  const currentPath = window.location.pathname;
  const isUserPortal = currentPath === '/user-portal' || currentPath === '/subscription';
  
  const token = isUserPortal 
    ? (localStorage.getItem('userPortalAccessToken') || localStorage.getItem('accessToken'))
    : localStorage.getItem('accessToken');
  
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

export const getSubscriptionPlans = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subscriptions/plans`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const createSubscription = async (subscriptionData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/subscriptions/create`, subscriptionData, getAuthHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getMySubscription = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subscriptions/my-subscription`, getAuthHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getMySubscriptionHistory = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subscriptions/history`, getAuthHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const checkSubscriptionStatus = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subscriptions/status`, getAuthHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const cancelSubscription = async (subscriptionId) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/subscriptions/cancel/${subscriptionId}`, {}, getAuthHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const createSubscriptionPlan = async (subscriptionData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/subscriptions/plans`, subscriptionData, getAuthHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const listSubscriptionPlans = async (page = 1, limit = 10) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subscriptions/admin-plans`, {
            ...getAuthHeaders(),
            // pageNo is sent as an alias — this repo has endpoints on both conventions
            params: { page, pageNo: page, limit },
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const deactivateSubscriptionPlans = async (id) => {
    try {
        const response = await axios.patch(
            `${API_BASE_URL}/subscriptions/admin-plans/${id}`, // ✅ ID URL me
            {
                isActive: false, // ✅ ONLY payload
            },
            getAuthHeaders() // ✅ headers separate
        );

        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};